import CategoryAttributesFormList from 'app/components/Core/CategoryAttribute/FormList'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import KTextArea from 'app/components/Modules/Form/KTextArea'
import { FormRecord } from 'app/components/Modules/Form/typing'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

const MissingInformationForm: React.FC<Partial<React.ComponentProps<typeof KForm>>> = (props) => {
  const payloadModifier = (values: FormRecord) => {
    const { category_attributes, ...payload } = values

    return {
      ...payload,
      attribute_values: category_attributes.map((i: ICategoryAttribute) => ({
        ...i.attribute_value,
        attribute_detail_id: i.attribute_detail.id
      }))
    }
  }

  return (
    <KForm
      recordType={RecordType.line_item}
      layout="vertical"
      showParams={{
        params: {
          includes: [RecordType.plurify().sub_item, RecordType.plurify().category_attribute]
        }
      }}
      payloadModifier={payloadModifier}
      {...props}>
      <KInputText name="dates" readOnly />
      <CategoryAttributesFormList />
      <KTextArea name="annotation" />
    </KForm>
  )
}

export default MissingInformationForm
